import {
  FETCH_PRODUCT_SUCCESS,
  FETCH_DETAIL_PRODUCT_SUCCESS,
} from "./actionType";

import swal from "sweetalert";

export const productFetchSuccess = function (payload) {
  return {
    type: FETCH_PRODUCT_SUCCESS,
    payload,
  };
};

export const detailProductFetchSuccess = function (payload) {
  return {
    type: FETCH_DETAIL_PRODUCT_SUCCESS,
    payload,
  };
}; 

export const fetchProducts = function (payload) {
  return (dispatch) => {
    fetch(
      `https://why-florist.herokuapp.com/products?category=${payload.categoryId}&search=${payload.name}`
    )
      .then((response) => {
        if (!response.ok) {
          swal("Error", response.statusText, "error");
        }
        return response.json();
      })
      .then((data) => dispatch(productFetchSuccess(data)));
  };
};

export const fetchProductDetail = function (id) {
  return (dispatch) => {
    fetch(`https://why-florist.herokuapp.com/products/${id}`, {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          swal("Error", response, "error");
        }
        return response.json();
      })
      .then((data) => {
        dispatch(detailProductFetchSuccess(data));
      });
  };
};
